// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AccordionItem-module__font-s-10___obgYf {
  font-size: 10px !important;
}

.AccordionItem-module__font-s-12___CVUku {
  font-size: 12px !important;
}

.AccordionItem-module__font-s-13___pGIXU {
  font-size: 13px !important;
}

.AccordionItem-module__font-s-14___wPCtk {
  font-size: 14px !important;
}

.AccordionItem-module__font-s-15___QFyp5 {
  font-size: 15px !important;
}

.AccordionItem-module__font-s-16___V2n8T {
  font-size: 16px !important;
}

.AccordionItem-module__font-s-18___IJ_NT {
  font-size: 18px !important;
}

.AccordionItem-module__font-s-20___PlXni {
  font-size: 20px !important;
}

.AccordionItem-module__font-s-22___Dxa9C {
  font-size: 22px !important;
}

.AccordionItem-module__font-s-28___mCM1N {
  font-size: 28px !important;
}

.AccordionItem-module__font-w-400___P0UL5 {
  font-weight: 400 !important;
}

.AccordionItem-module__font-w-500___fa9VN {
  font-weight: 500 !important;
}

.AccordionItem-module__font-w-600___SccdR {
  font-weight: 600 !important;
}

.AccordionItem-module__font-w-700___MnPmD {
  font-weight: 700 !important;
}

.AccordionItem-module__p-5___eohGg {
  padding: 5px !important;
}

.AccordionItem-module__p-12___ljy61 {
  padding: 12px !important;
}

.AccordionItem-module__p-16___RHVMB {
  padding: 16px !important;
}

.AccordionItem-module__p-30___kV1Y2 {
  padding: 30px !important;
}

.AccordionItem-module__p-b-0___orcXV {
  padding-bottom: 0 !important;
}

.AccordionItem-module__p-b-5___yG1Ep {
  padding-bottom: 5px !important;
}

.AccordionItem-module__p-b-10___xNSMs {
  padding-bottom: 10px !important;
}

.AccordionItem-module__p-b-12___GvtfS {
  padding-bottom: 12px !important;
}

.AccordionItem-module__p-b-16___yKq5h {
  padding-bottom: 16px !important;
}

.AccordionItem-module__p-b-18___kgtsr {
  padding-bottom: 18px !important;
}

.AccordionItem-module__p-b-20___KnQZM {
  padding-bottom: 20px !important;
}

.AccordionItem-module__p-b-25___IyfJ7 {
  padding-bottom: 25px !important;
}

.AccordionItem-module__p-b-30___rxfnE {
  padding-bottom: 30px !important;
}

.AccordionItem-module__p-b-50___yeIeS {
  padding-bottom: 50px !important;
}

.AccordionItem-module__p-t-0___tWPka {
  padding-top: 0 !important;
}

.AccordionItem-module__p-t-12___KWEW5 {
  padding-top: 12px !important;
}

.AccordionItem-module__p-t-16___rUqK1 {
  padding-top: 16px !important;
}

.AccordionItem-module__p-t-18___FLt0o {
  padding-top: 18px !important;
}

.AccordionItem-module__p-t-20___TpeQ0 {
  padding-top: 20px !important;
}

.AccordionItem-module__p-t-30___erWEP {
  padding-top: 30px !important;
}

.AccordionItem-module__p-t-40___b5822 {
  padding-top: 40px !important;
}

.AccordionItem-module__p-t-50___tuLi5 {
  padding-top: 50px !important;
}

.AccordionItem-module__p-l-20___sHT38 {
  padding-left: 20px !important;
}

.AccordionItem-module__p-l-30___RWUT9 {
  padding-left: 30px !important;
}

.AccordionItem-module__p-l-40___LE_6N {
  padding-left: 40px !important;
}

.AccordionItem-module__p-r-16___Iv5Xh {
  padding-right: 16px !important;
}

.AccordionItem-module__p-r-20___etJa3 {
  padding-right: 20px !important;
}

.AccordionItem-module__p-r-30___PqX2A {
  padding-right: 30px !important;
}

.AccordionItem-module__p-r-50___WxgzH {
  padding-right: 50px !important;
}

.AccordionItem-module__p-r-60___mEvNi {
  padding-right: 60px !important;
}

.AccordionItem-module__m-b-1___On1zs {
  margin-bottom: 1px !important;
}

.AccordionItem-module__m-b-2___w2N7R {
  margin-bottom: 2px !important;
}

.AccordionItem-module__m-b-6___D1mDx {
  margin-bottom: 6px !important;
}

.AccordionItem-module__m-b-8___mycmt {
  margin-bottom: 8px !important;
}

.AccordionItem-module__m-b-10___wj58D {
  margin-bottom: 10px !important;
}

.AccordionItem-module__m-b-14___z5cNB {
  margin-bottom: 14px !important;
}

.AccordionItem-module__m-b-16___Obtw0 {
  margin-bottom: 16px !important;
}

.AccordionItem-module__m-b-20___EII1f {
  margin-bottom: 20px !important;
}

.AccordionItem-module__m-b-22___h8Kib {
  margin-bottom: 22px !important;
}

.AccordionItem-module__m-b-24___VZ0Wv {
  margin-bottom: 24px !important;
}

.AccordionItem-module__m-b-30___Tg4aT {
  margin-bottom: 30px !important;
}

.AccordionItem-module__m-b-32___S9eo6 {
  margin-bottom: 32px !important;
}

.AccordionItem-module__m-b-40___wydQh {
  margin-bottom: 40px !important;
}

.AccordionItem-module__m-t-2___LXkbQ {
  margin-top: 2px !important;
}

.AccordionItem-module__m-t-3___BAJYR {
  margin-top: 3px !important;
}

.AccordionItem-module__m-t-4___GNOMy {
  margin-top: 4px !important;
}

.AccordionItem-module__m-t-5___CSEpl {
  margin-top: 5px !important;
}

.AccordionItem-module__m-t-8___PniGS {
  margin-top: 8px !important;
}

.AccordionItem-module__m-t-10___sH8Bv {
  margin-top: 10px !important;
}

.AccordionItem-module__m-t-15___xjYct {
  margin-top: 15px !important;
}

.AccordionItem-module__m-t-16___mhGjS {
  margin-top: 16px !important;
}

.AccordionItem-module__m-t-20___Qi6YQ {
  margin-top: 20px !important;
}

.AccordionItem-module__m-t-22___tendS {
  margin-top: 22px !important;
}

.AccordionItem-module__m-t-30___TKgmC {
  margin-top: 30px !important;
}

.AccordionItem-module__m-t-32___WhDn3 {
  margin-top: 32px !important;
}

.AccordionItem-module__m-l-auto___GYWoa {
  margin-left: auto !important;
}

.AccordionItem-module__m-l-4___HdCj0 {
  margin-left: 4px !important;
}

.AccordionItem-module__m-l-5___xgYFB {
  margin-left: 5px !important;
}

.AccordionItem-module__m-l-6___aZ1XK {
  margin-left: 6px !important;
}

.AccordionItem-module__m-l-8___mv2Nx {
  margin-left: 8px !important;
}

.AccordionItem-module__m-l-10___cb2HN {
  margin-left: 10px !important;
}

.AccordionItem-module__m-l-16___gLiku {
  margin-left: 16px !important;
}

.AccordionItem-module__m-l-20___Kje9w {
  margin-left: 20px !important;
}

.AccordionItem-module__m-l-24___KRGWB {
  margin-left: 24px !important;
}

.AccordionItem-module__m-l-30___EzDgj {
  margin-left: 30px !important;
}

.AccordionItem-module__m-l-35___bHYUj {
  margin-left: 35px !important;
}

.AccordionItem-module__m-l-40___xm3tW {
  margin-left: 40px !important;
}

.AccordionItem-module__m-r-8___SNVJo {
  margin-right: 8px !important;
}

.AccordionItem-module__m-r-10___xB1QI {
  margin-right: 10px !important;
}

.AccordionItem-module__m-r-16___JBUDi {
  margin-right: 16px !important;
}

.AccordionItem-module__m-r-20___nsLBP {
  margin-right: 20px !important;
}

.AccordionItem-module__m-r-24___aosSk {
  margin-right: 24px !important;
}

.AccordionItem-module__m-r-30___a7ADD {
  margin-right: 30px !important;
}

.AccordionItem-module__m-r-40___x1eL3 {
  margin-right: 40px !important;
}

.AccordionItem-module__border-r-3___c261S {
  border-radius: 3px !important;
}

.AccordionItem-module__border-r-4___eJPvc {
  border-radius: 4px !important;
}

.AccordionItem-module__border-r-6___WeCYW {
  border-radius: 6px !important;
}

.AccordionItem-module__border-r-10___aGYdA {
  border-radius: 10px !important;
}

.AccordionItem-module__border-r-12___hfICQ {
  border-radius: 12px !important;
}

.AccordionItem-module__border-r-16___zZrA_ {
  border-radius: 16px !important;
}

.AccordionItem-module__border-r-50___W_4NY {
  border-radius: 50% !important;
}

.AccordionItem-module__primary-border___XtjtN {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.AccordionItem-module__primary-border-b___mGW9c {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.AccordionItem-module__primary-border-t___LV34N {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.AccordionItem-module__primary-border-l___kDPvK {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.AccordionItem-module__primary-border-r___me2Ie {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.AccordionItem-module__secondary-border___wqbM1 {
  border: 1px solid #637768;
}

.AccordionItem-module__secondary-border-b___agKrm {
  border-bottom: 1px solid #637768;
}

.AccordionItem-module__secondary-border-t___y6zYL {
  border-top: 1px solid #637768;
}

.AccordionItem-module__secondary-border-l___fEV7D {
  border-left: 1px solid #637768;
}

.AccordionItem-module__secondary-border-r___OfdO6 {
  border-right: 1px solid #637768;
}

.AccordionItem-module__gap-0___mRP4p {
  gap: 0 !important;
}

.AccordionItem-module__gap-2___xBySi {
  gap: 2px !important;
}

.AccordionItem-module__gap-4___iAn1u {
  gap: 4px !important;
}

.AccordionItem-module__gap-5___V0_SH {
  gap: 5px !important;
}

.AccordionItem-module__gap-6___iOEJp {
  gap: 6px !important;
}

.AccordionItem-module__gap-8___zwEli {
  gap: 8px !important;
}

.AccordionItem-module__gap-10___NEPz9 {
  gap: 10px !important;
}

.AccordionItem-module__gap-12___ntZt_ {
  gap: 12px !important;
}

.AccordionItem-module__gap-14___CxKy7 {
  gap: 14px !important;
}

.AccordionItem-module__gap-16___I4j0Q {
  gap: 16px !important;
}

.AccordionItem-module__gap-18___uv9Py {
  gap: 18px !important;
}

.AccordionItem-module__gap-20___yU4dy {
  gap: 20px !important;
}

.AccordionItem-module__gap-24___nd1hF {
  gap: 24px !important;
}

.AccordionItem-module__gap-26___BC2NK {
  gap: 26px !important;
}

.AccordionItem-module__gap-30___mwkFK {
  gap: 30px !important;
}

.AccordionItem-module__gap-32___k9XoK {
  gap: 32px !important;
}

.AccordionItem-module__gap-40___IKfMp {
  gap: 40px !important;
}

.AccordionItem-module__gap-50___psMfd {
  gap: 50px !important;
}

.AccordionItem-module__flex-1___x5N9J {
  flex: 1;
}

.AccordionItem-module__flex-none____z_Ov {
  flex: none !important;
}

.AccordionItem-module__flex-column___bL7mg {
  display: flex;
  flex-direction: column !important;
}

.AccordionItem-module__flex-row___tCGT3 {
  display: flex;
  flex-direction: row !important;
}

.AccordionItem-module__vertically-centered___O308S {
  display: flex;
  align-items: center !important;
}

.AccordionItem-module__horizontally-centered___NpRbA {
  display: flex;
  justify-content: center !important;
}

.AccordionItem-module__horizontally-end___yCc85 {
  display: flex;
  justify-content: end !important;
}

.AccordionItem-module__vertically-start___rcE0C {
  display: flex;
  align-items: start !important;
}

.AccordionItem-module__space-between___cfi_G {
  display: flex;
  justify-content: space-between !important;
}

.AccordionItem-module__flex-wrap___TVjmT {
  flex-wrap: wrap !important;
}

.AccordionItem-module__height-100___vXuA9 {
  height: 100%;
}

.AccordionItem-module__width-50___cjgEG {
  width: 50% !important;
}

.AccordionItem-module__width-100___ijMk2 {
  width: 100%;
}

.AccordionItem-module__cursor-pointer____ZzuK {
  cursor: pointer;
}

.AccordionItem-module__cursor-not-allowed___V1FR8 {
  cursor: not-allowed !important;
}

.AccordionItem-module__absolute-centered___unelg {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.AccordionItem-module__absolute___BwPqy {
  position: absolute;
}

.AccordionItem-module__relative___N64B4 {
  position: relative;
}

.AccordionItem-module__fixed___vOIuE {
  position: fixed;
}

.AccordionItem-module__visible___QPizb {
  opacity: 1;
}

.AccordionItem-module__invisible___rZqE5 {
  opacity: 0;
}

.AccordionItem-module__col-90___FwNQ4 {
  width: 90% !important;
}

.AccordionItem-module__col-auto___gbdko {
  width: auto !important;
}

.AccordionItem-module__medical-tabs___t6pbl {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.AccordionItem-module__medical-table-new___rSUdp {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.AccordionItem-module__medical-table-new___rSUdp:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.AccordionItem-module__medical-table-new___rSUdp::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.AccordionItem-module__medical-table-new___rSUdp::-webkit-scrollbar-track {
  display: none;
}
.AccordionItem-module__medical-table-new___rSUdp.AccordionItem-module__no-pagination___c9fDL {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.AccordionItem-module__medical-table-new___rSUdp.AccordionItem-module__no-pagination___c9fDL:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.AccordionItem-module__medical-table-new___rSUdp.AccordionItem-module__no-pagination___c9fDL::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.AccordionItem-module__medical-table-new___rSUdp.AccordionItem-module__no-pagination___c9fDL::-webkit-scrollbar-track {
  display: none;
}

.AccordionItem-module__medical-table-empty___FmOvC {
  padding: 14px 40px !important;
}

.AccordionItem-module__icon-btn___QJ54D {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.AccordionItem-module__search-icon___iS_zQ {
  width: 24px;
  height: 24px;
  align-self: center;
}

.AccordionItem-module__disable-select___Qwukx {
  user-select: none;
}

.AccordionItem-module__break-word___ITa7Z {
  word-break: break-word;
}

.AccordionItem-module__popup-clear-btn___obvlq {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.AccordionItem-module__scroll-m-b-20___BX8wO {
  scroll-margin-bottom: 20px;
}

.AccordionItem-module__container___p_1CL {
  background-color: #fdfcfa;
  color: #375844;
}
.AccordionItem-module__container___p_1CL .AccordionItem-module__arrow___kEs_s {
  transform: rotate(-90deg);
  transition: transform 0.4s ease;
}
.AccordionItem-module__container___p_1CL .AccordionItem-module__arrow___kEs_s.AccordionItem-module__rotate___1Dddh {
  transform: rotate(0deg);
}
.AccordionItem-module__container___p_1CL .AccordionItem-module__content___Dn4OC {
  padding: 12px 20px;
}
.AccordionItem-module__container___p_1CL .AccordionItem-module__content___Dn4OC .AccordionItem-module__readOnly___qzkII {
  white-space: break-spaces;
}
.AccordionItem-module__container___p_1CL .AccordionItem-module__content___Dn4OC .AccordionItem-module__textAreaContainer___gvTZ5 {
  max-height: 315px;
  overflow-y: scroll;
}
.AccordionItem-module__container___p_1CL .AccordionItem-module__content___Dn4OC .AccordionItem-module__textAreaContainer___gvTZ5 .AccordionItem-module__textArea___PNaQ5 {
  border-radius: 1px 1px 8px 8px !important;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/SmartGoals/WellnessPlan/AccordionItem/AccordionItem.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,yBAAA;EACA,cAAA;AA8pBF;AA5pBE;EACE,yBAAA;EACA,+BAAA;AA8pBJ;AA5pBI;EACE,uBAAA;AA8pBN;AA1pBE;EACE,kBAAA;AA4pBJ;AA1pBI;EACE,yBAAA;AA4pBN;AAzpBI;EACE,iBAAA;EACA,kBAAA;AA2pBN;AAzpBM;EACE,yCAAA;AA2pBR","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  background-color: get-color(grayNew, ultra-light);\n  color: get-color(greenNew, dark);\n\n  .arrow {\n    transform: rotate(-90deg);\n    transition: transform 0.4s ease;\n\n    &.rotate {\n      transform: rotate(0deg);\n    }\n  }\n\n  .content {\n    padding: 12px 20px;\n\n    .readOnly {\n      white-space: break-spaces;\n    }\n\n    .textAreaContainer {\n      max-height: 315px;\n      overflow-y: scroll;\n\n      .textArea {\n        border-radius: 1px 1px 8px 8px !important;\n      }\n    }\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `AccordionItem-module__font-s-10___obgYf`,
	"fontS12": `AccordionItem-module__font-s-12___CVUku`,
	"fontS13": `AccordionItem-module__font-s-13___pGIXU`,
	"fontS14": `AccordionItem-module__font-s-14___wPCtk`,
	"fontS15": `AccordionItem-module__font-s-15___QFyp5`,
	"fontS16": `AccordionItem-module__font-s-16___V2n8T`,
	"fontS18": `AccordionItem-module__font-s-18___IJ_NT`,
	"fontS20": `AccordionItem-module__font-s-20___PlXni`,
	"fontS22": `AccordionItem-module__font-s-22___Dxa9C`,
	"fontS28": `AccordionItem-module__font-s-28___mCM1N`,
	"fontW400": `AccordionItem-module__font-w-400___P0UL5`,
	"fontW500": `AccordionItem-module__font-w-500___fa9VN`,
	"fontW600": `AccordionItem-module__font-w-600___SccdR`,
	"fontW700": `AccordionItem-module__font-w-700___MnPmD`,
	"p5": `AccordionItem-module__p-5___eohGg`,
	"p12": `AccordionItem-module__p-12___ljy61`,
	"p16": `AccordionItem-module__p-16___RHVMB`,
	"p30": `AccordionItem-module__p-30___kV1Y2`,
	"pB0": `AccordionItem-module__p-b-0___orcXV`,
	"pB5": `AccordionItem-module__p-b-5___yG1Ep`,
	"pB10": `AccordionItem-module__p-b-10___xNSMs`,
	"pB12": `AccordionItem-module__p-b-12___GvtfS`,
	"pB16": `AccordionItem-module__p-b-16___yKq5h`,
	"pB18": `AccordionItem-module__p-b-18___kgtsr`,
	"pB20": `AccordionItem-module__p-b-20___KnQZM`,
	"pB25": `AccordionItem-module__p-b-25___IyfJ7`,
	"pB30": `AccordionItem-module__p-b-30___rxfnE`,
	"pB50": `AccordionItem-module__p-b-50___yeIeS`,
	"pT0": `AccordionItem-module__p-t-0___tWPka`,
	"pT12": `AccordionItem-module__p-t-12___KWEW5`,
	"pT16": `AccordionItem-module__p-t-16___rUqK1`,
	"pT18": `AccordionItem-module__p-t-18___FLt0o`,
	"pT20": `AccordionItem-module__p-t-20___TpeQ0`,
	"pT30": `AccordionItem-module__p-t-30___erWEP`,
	"pT40": `AccordionItem-module__p-t-40___b5822`,
	"pT50": `AccordionItem-module__p-t-50___tuLi5`,
	"pL20": `AccordionItem-module__p-l-20___sHT38`,
	"pL30": `AccordionItem-module__p-l-30___RWUT9`,
	"pL40": `AccordionItem-module__p-l-40___LE_6N`,
	"pR16": `AccordionItem-module__p-r-16___Iv5Xh`,
	"pR20": `AccordionItem-module__p-r-20___etJa3`,
	"pR30": `AccordionItem-module__p-r-30___PqX2A`,
	"pR50": `AccordionItem-module__p-r-50___WxgzH`,
	"pR60": `AccordionItem-module__p-r-60___mEvNi`,
	"mB1": `AccordionItem-module__m-b-1___On1zs`,
	"mB2": `AccordionItem-module__m-b-2___w2N7R`,
	"mB6": `AccordionItem-module__m-b-6___D1mDx`,
	"mB8": `AccordionItem-module__m-b-8___mycmt`,
	"mB10": `AccordionItem-module__m-b-10___wj58D`,
	"mB14": `AccordionItem-module__m-b-14___z5cNB`,
	"mB16": `AccordionItem-module__m-b-16___Obtw0`,
	"mB20": `AccordionItem-module__m-b-20___EII1f`,
	"mB22": `AccordionItem-module__m-b-22___h8Kib`,
	"mB24": `AccordionItem-module__m-b-24___VZ0Wv`,
	"mB30": `AccordionItem-module__m-b-30___Tg4aT`,
	"mB32": `AccordionItem-module__m-b-32___S9eo6`,
	"mB40": `AccordionItem-module__m-b-40___wydQh`,
	"mT2": `AccordionItem-module__m-t-2___LXkbQ`,
	"mT3": `AccordionItem-module__m-t-3___BAJYR`,
	"mT4": `AccordionItem-module__m-t-4___GNOMy`,
	"mT5": `AccordionItem-module__m-t-5___CSEpl`,
	"mT8": `AccordionItem-module__m-t-8___PniGS`,
	"mT10": `AccordionItem-module__m-t-10___sH8Bv`,
	"mT15": `AccordionItem-module__m-t-15___xjYct`,
	"mT16": `AccordionItem-module__m-t-16___mhGjS`,
	"mT20": `AccordionItem-module__m-t-20___Qi6YQ`,
	"mT22": `AccordionItem-module__m-t-22___tendS`,
	"mT30": `AccordionItem-module__m-t-30___TKgmC`,
	"mT32": `AccordionItem-module__m-t-32___WhDn3`,
	"mLAuto": `AccordionItem-module__m-l-auto___GYWoa`,
	"mL4": `AccordionItem-module__m-l-4___HdCj0`,
	"mL5": `AccordionItem-module__m-l-5___xgYFB`,
	"mL6": `AccordionItem-module__m-l-6___aZ1XK`,
	"mL8": `AccordionItem-module__m-l-8___mv2Nx`,
	"mL10": `AccordionItem-module__m-l-10___cb2HN`,
	"mL16": `AccordionItem-module__m-l-16___gLiku`,
	"mL20": `AccordionItem-module__m-l-20___Kje9w`,
	"mL24": `AccordionItem-module__m-l-24___KRGWB`,
	"mL30": `AccordionItem-module__m-l-30___EzDgj`,
	"mL35": `AccordionItem-module__m-l-35___bHYUj`,
	"mL40": `AccordionItem-module__m-l-40___xm3tW`,
	"mR8": `AccordionItem-module__m-r-8___SNVJo`,
	"mR10": `AccordionItem-module__m-r-10___xB1QI`,
	"mR16": `AccordionItem-module__m-r-16___JBUDi`,
	"mR20": `AccordionItem-module__m-r-20___nsLBP`,
	"mR24": `AccordionItem-module__m-r-24___aosSk`,
	"mR30": `AccordionItem-module__m-r-30___a7ADD`,
	"mR40": `AccordionItem-module__m-r-40___x1eL3`,
	"borderR3": `AccordionItem-module__border-r-3___c261S`,
	"borderR4": `AccordionItem-module__border-r-4___eJPvc`,
	"borderR6": `AccordionItem-module__border-r-6___WeCYW`,
	"borderR10": `AccordionItem-module__border-r-10___aGYdA`,
	"borderR12": `AccordionItem-module__border-r-12___hfICQ`,
	"borderR16": `AccordionItem-module__border-r-16___zZrA_`,
	"borderR50": `AccordionItem-module__border-r-50___W_4NY`,
	"primaryBorder": `AccordionItem-module__primary-border___XtjtN`,
	"primaryBorderB": `AccordionItem-module__primary-border-b___mGW9c`,
	"primaryBorderT": `AccordionItem-module__primary-border-t___LV34N`,
	"primaryBorderL": `AccordionItem-module__primary-border-l___kDPvK`,
	"primaryBorderR": `AccordionItem-module__primary-border-r___me2Ie`,
	"secondaryBorder": `AccordionItem-module__secondary-border___wqbM1`,
	"secondaryBorderB": `AccordionItem-module__secondary-border-b___agKrm`,
	"secondaryBorderT": `AccordionItem-module__secondary-border-t___y6zYL`,
	"secondaryBorderL": `AccordionItem-module__secondary-border-l___fEV7D`,
	"secondaryBorderR": `AccordionItem-module__secondary-border-r___OfdO6`,
	"gap0": `AccordionItem-module__gap-0___mRP4p`,
	"gap2": `AccordionItem-module__gap-2___xBySi`,
	"gap4": `AccordionItem-module__gap-4___iAn1u`,
	"gap5": `AccordionItem-module__gap-5___V0_SH`,
	"gap6": `AccordionItem-module__gap-6___iOEJp`,
	"gap8": `AccordionItem-module__gap-8___zwEli`,
	"gap10": `AccordionItem-module__gap-10___NEPz9`,
	"gap12": `AccordionItem-module__gap-12___ntZt_`,
	"gap14": `AccordionItem-module__gap-14___CxKy7`,
	"gap16": `AccordionItem-module__gap-16___I4j0Q`,
	"gap18": `AccordionItem-module__gap-18___uv9Py`,
	"gap20": `AccordionItem-module__gap-20___yU4dy`,
	"gap24": `AccordionItem-module__gap-24___nd1hF`,
	"gap26": `AccordionItem-module__gap-26___BC2NK`,
	"gap30": `AccordionItem-module__gap-30___mwkFK`,
	"gap32": `AccordionItem-module__gap-32___k9XoK`,
	"gap40": `AccordionItem-module__gap-40___IKfMp`,
	"gap50": `AccordionItem-module__gap-50___psMfd`,
	"flex1": `AccordionItem-module__flex-1___x5N9J`,
	"flexNone": `AccordionItem-module__flex-none____z_Ov`,
	"flexColumn": `AccordionItem-module__flex-column___bL7mg`,
	"flexRow": `AccordionItem-module__flex-row___tCGT3`,
	"verticallyCentered": `AccordionItem-module__vertically-centered___O308S`,
	"horizontallyCentered": `AccordionItem-module__horizontally-centered___NpRbA`,
	"horizontallyEnd": `AccordionItem-module__horizontally-end___yCc85`,
	"verticallyStart": `AccordionItem-module__vertically-start___rcE0C`,
	"spaceBetween": `AccordionItem-module__space-between___cfi_G`,
	"flexWrap": `AccordionItem-module__flex-wrap___TVjmT`,
	"height100": `AccordionItem-module__height-100___vXuA9`,
	"width50": `AccordionItem-module__width-50___cjgEG`,
	"width100": `AccordionItem-module__width-100___ijMk2`,
	"cursorPointer": `AccordionItem-module__cursor-pointer____ZzuK`,
	"cursorNotAllowed": `AccordionItem-module__cursor-not-allowed___V1FR8`,
	"absoluteCentered": `AccordionItem-module__absolute-centered___unelg`,
	"absolute": `AccordionItem-module__absolute___BwPqy`,
	"relative": `AccordionItem-module__relative___N64B4`,
	"fixed": `AccordionItem-module__fixed___vOIuE`,
	"visible": `AccordionItem-module__visible___QPizb`,
	"invisible": `AccordionItem-module__invisible___rZqE5`,
	"col90": `AccordionItem-module__col-90___FwNQ4`,
	"colAuto": `AccordionItem-module__col-auto___gbdko`,
	"medicalTabs": `AccordionItem-module__medical-tabs___t6pbl`,
	"medicalTableNew": `AccordionItem-module__medical-table-new___rSUdp`,
	"noPagination": `AccordionItem-module__no-pagination___c9fDL`,
	"medicalTableEmpty": `AccordionItem-module__medical-table-empty___FmOvC`,
	"iconBtn": `AccordionItem-module__icon-btn___QJ54D`,
	"searchIcon": `AccordionItem-module__search-icon___iS_zQ`,
	"disableSelect": `AccordionItem-module__disable-select___Qwukx`,
	"breakWord": `AccordionItem-module__break-word___ITa7Z`,
	"popupClearBtn": `AccordionItem-module__popup-clear-btn___obvlq`,
	"scrollMB20": `AccordionItem-module__scroll-m-b-20___BX8wO`,
	"container": `AccordionItem-module__container___p_1CL`,
	"arrow": `AccordionItem-module__arrow___kEs_s`,
	"rotate": `AccordionItem-module__rotate___1Dddh`,
	"content": `AccordionItem-module__content___Dn4OC`,
	"readOnly": `AccordionItem-module__readOnly___qzkII`,
	"textAreaContainer": `AccordionItem-module__textAreaContainer___gvTZ5`,
	"textArea": `AccordionItem-module__textArea___PNaQ5`
};
module.exports = ___CSS_LOADER_EXPORT___;
